import { EventBus } from '../../helpers';

type ContactsTierSelectEvents = {
  contactTierChanged: [tier: string];
};

class ContactsTierSelectEventBus extends EventBus<ContactsTierSelectEvents> {}

export const contactsTierSelectEventBus = new ContactsTierSelectEventBus();
